<template>
    <div class="">
        <DataTable v-if="DataTable_render" :columns="columns" :data="MusteriGecmisIslemListesi"
            v-on:set-child-data="getDataChild" :editbutton="false" />

    </div>
</template>

<script>
import DataTable from "../../../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../../../services/GlobalServis";
export default {
    props: {
        pMusteri: { default: "0", type: String }
    },
    data() {
        return {
            DataTable_render: false,
            MusteriGecmisIslemListesi: [],
            columns: [
                { field: "UrunAd", header: "Ürün Adı" },
                { field: "Tutar", header: "Tutar" },
                { field: "IslemTarihSaat", header: "İşlem Tarih" },
            ],
        };
    },
    methods: {
        InitServis() {
            let data = {
                Danisan_rowid: this.pMusteri
            };

            GlobalServis.GlobalServis("POST", "GetDanisanGecmis", data).then((res) => {
                if (res.status == 200) {
                    this.MusteriGecmisIslemListesi = res.data;
                    this.DataTable_render = true;
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        },
    },
    mounted() {
        this.InitServis();
    },
    components: {
        DataTable,
    },

};
</script>